<template>
  <div class="success-container">
    <div class="success-icon">✅</div>
    <h1>Payment Successful!</h1>
    <p>Thank you for your payment. Your transaction has been completed successfully.</p>

    

    <div v-if="loading" class="loading">Loading payment details...</div>

    <div v-if="error" class="error-message">{{ error }}</div>
<!-- <div v-if="fulfillmentError" class="error-message"> Fulfillment Error: {{ fulfillmentError }}</div> -->

  <div v-if="paymentDetails" class="details">
  <h3>Payment Details (Stripe)</h3>
  <p class="detail-row"> <strong>Order ID:</strong> <span class="detail-value">{{ orderId }}</span> </p>
<p><strong>Payment Status:</strong> {{ paymentDetails.payment_status.charAt(0).toUpperCase() + paymentDetails.payment_status.slice(1) }}</p>
  <p><strong>Amount:</strong> ${{ (paymentDetails.amount_total / 100).toFixed(2) }} {{ paymentDetails.currency.toUpperCase() }}</p>
 <!-- <p><strong>Session Status:</strong> {{ paymentDetails.status }}</p>-->
  <p v-if="paymentDetails.customer_email" class="detail-row"><strong>Customer Email:</strong><span class="detail-value"> {{ paymentDetails.customer_email }} </span></p>
 <p class="detail-row"> <strong>Payment Intent:</strong> <span class="detail-value">{{ paymentDetails.payment_intent }}</span> </p>
</div>


    <div class="button-group">
     <!-- <button class="btn" @click="goBack">← Go Back</button>-->
      <router-link to="/" class="btn">Return to Home</router-link>
     <!-- <button class="btn btn-secondary" @click="fetchPaymentDetails">Refresh Details</button>-->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

//const API_BASE_URL = "https://storyversewebapp-dkceefdmfqcwesc7.centralus-01.azurewebsites.net";
const API_BASE_URL = "https://api.craftmystories.com";
const sessionId = ref(null);
const orderId = ref(null); 
const fulfillmentError = ref("");
console.log('Stripe session id:', sessionId.value || 'Not available');
const paymentDetails = ref(null);
const orderData = ref(null);
const loading = ref(true);
const error = ref("");



const urlParams = new URLSearchParams(window.location.search);
sessionId.value = urlParams.get("session_id")|| urlParams.get("session_Id") 
               || urlParams.get('sessionId');


orderId.value = urlParams.get("orderId");

console.log('Stripe session id:', sessionId.value || 'Not available');
console.log('Application order id:', orderId.value || 'Not available');


const fetchPaymentDetails = async () => {
    loading.value = true;
    error.value = "";
    fulfillmentError.value = "";
    
    if (!orderId.value) {
        error.value = "CRITICAL ERROR: No Order ID found in URL. Cannot finalize order or display details.";
        loading.value = false;
        return;
    }

    
    try {
        const orderUrl = `${API_BASE_URL}/api/orders/${orderId.value}`;
        const res = await fetch(orderUrl, { credentials: "include" });

        if (!res.ok) {
            const errorDetail = await res.json().catch(() => ({}));
            throw new Error(errorDetail.detail || "Could not load order metadata from server.");
        }
        
        orderData.value = await res.json();
        console.log(`[API] Order details loaded for: ${orderId.value}`);

    } catch (e) {
        console.error("Error loading order details:", e);
        // Log the error but continue to attempt Stripe/Fulfillment check
        error.value = `Could not load order details: ${e.message}`; 
    }
    
   

    if (!sessionId.value) {
        // If Stripe ID is missing, we stop here but still show the order details loaded above.
        error.value = error.value || "No Stripe session ID found in URL. Displaying available order details.";
        loading.value = false;
        return;
    }
    
    try {
       
        const response = await fetch(`${API_BASE_URL}/stripe/confirm-embedded-checkout/${sessionId.value}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
        
        if (!response.ok) {
            const errorDetail = await response.json().catch(() => ({ message: `HTTP status ${response.status}` }));
            throw new Error(errorDetail.message || `Server error with status ${response.status}.`);
        }
        const result = await response.json();

        if (result.success && result.session.payment_status === 'paid') {
            paymentDetails.value = result.session;
            
            
            try {
                const triggerUrl = `${API_BASE_URL}/orders/triger-book-creation/?order_id=${orderId.value}`; 
                console.log(`[Stripe Success] Calling fulfillment trigger URL: ${triggerUrl}`);

                const triggerRes = await fetch(triggerUrl, { 
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                });

                if (!triggerRes.ok) {
                    const errorDetail = await triggerRes.json().catch(() => ({ detail: `HTTP status ${triggerRes.status}` }));
                    console.error("Order fulfillment failed:", errorDetail);
                    fulfillmentError.value = errorDetail.detail || `Failed to finalize order (Status: ${triggerRes.status}).`;
                } else {
                    console.log("[API] Order fulfillment triggered successfully.");
                    await new Promise(resolve => setTimeout(resolve, 1500));
                   
               const updatedOrderRes = await fetch(`${API_BASE_URL}/api/orders/${orderId.value}`, { credentials: "include" });
                    
                    if (updatedOrderRes.ok) {
                        orderData.value = await updatedOrderRes.json();
                        console.log(`[API] Order details successfully refreshed with final status.`);
                    } else {
                        console.error("[API] Failed to re-fetch updated order details.");
                        fulfillmentError.value = "Fulfillment triggered, but failed to load final order status.";
                    }
                }
            } catch (fulfillErr) {
                console.error("Error calling fulfillment endpoint:", fulfillErr);
                fulfillmentError.value = `Order processing failed: ${fulfillErr.message}`;
            }
        } else if (result.success && result.session.payment_status !== 'paid') {
            error.value = `Payment not finalized. Status: ${result.session.payment_status}. Please wait or try refreshing.`;
        } else {
            throw new Error(result.message || "Failed to fetch payment details after successful transaction.");
        }
    } catch (err) {
        console.error("Error fetching payment details:", err);
        error.value = `${error.value ? error.value + '. ' : ''}Could not load payment details: ${err.message}`; 
    } finally {
        loading.value = false;
    }
};

const goBack = () => {
  window.history.back();
};

onMounted(() => {
  fetchPaymentDetails();

  if (window.opener && sessionId.value) {
    window.opener.postMessage(
      {
        type: "STRIPE_PAYMENT_SUCCESS",
        sessionId: sessionId.value,
      },
      "*"
    );

    setTimeout(() => {
      if (confirm("Payment successful! Close this window?")) {
        window.close();
      }
    }, 3000);
  }

  if (window.parent && window.parent !== window && sessionId.value) {
    window.parent.postMessage(
      {
        type: "STRIPE_PAYMENT_SUCCESS",
        session_Id: sessionId.value,
      },
      "*"
    );
  }
});
</script>

<style scoped>
.success-container {
  background-color: #f5f5dc;
  padding: 40px;
  border-radius: 10px;
  
  max-width: 600px;
  margin: 50px auto;
  text-align: center;
  font-family: Arial, sans-serif;
  
}

.success-icon {
  font-size: 60px;
  color: #28a745;
  margin-bottom: 20px;
}

.session-id {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  font-family: monospace;
  margin: 20px 0;
  word-break: break-all;
}

.btn {
  background-color: #635bff;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  margin: 10px;
}

.btn:hover {
  background-color: #5a52d5;
}

.loading {
  color: #666;
  font-style: italic;
}

.details {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin: 20px 0;
  text-align: left;
}

.button-group {
  margin-top: 20px;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.detail-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 8px;
}

.detail-row strong {
  margin-right: 6px;
  white-space: nowrap;
}

.detail-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 576px) {

    .success-container {
  background-color: #f5f5dc;
  padding: 10px;
  border-radius: 10px;
  max-width: 600px;
  margin: 50px auto;
  text-align: center;
  font-family: Arial, sans-serif;
  
}
  .detail-row {
    display: block;
  }

  .detail-row strong {
    display: block;
    margin-bottom: 4px;
  }

  .detail-value {
    display: block;
    white-space: normal; 
    word-break: break-word;
  }
}

@media (max-width: 768px) {
  .success-container {
    padding: 10px;
    border-radius: 10px;
    max-width: 100%;   /* full width on small screens */
    margin: 20px auto;
    text-align: center;
    font-family: Arial, sans-serif;
  }

  .detail-row {
    display: block;
  }

  .detail-row strong {
    display: block;
    margin-bottom: 4px;
  }

  .detail-value {
    display: block;
    white-space: normal;
    word-break: break-word;
  }
}

</style>